import { createApp } from 'vue'
import App from './App.vue'
import installElementPlus from './plugins/element'
import router from './router'
import SvgIcon from '@/components/SvgIcon.vue'

const app = createApp(App)
installElementPlus(app)
app.use(router)
app.component('icon', SvgIcon)
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/assets/svg', false, /\.svg$/)
requireAll(req)
app.mount('#app')
console.log("Last update:20210907 22:01")
